import { render, staticRenderFns } from "./UsersGroupsPage.vue?vue&type=template&id=d99c1c38"
import script from "./UsersGroupsPage.vue?vue&type=script&lang=js"
export * from "./UsersGroupsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports